import {observer} from 'mobx-react-lite';
import React from 'react';

import {DateFormat, FormattedDate} from './Date';
import {UserInitialsWithTooltip} from './UserInitialsWithTooltip';

function UDateAndUser({
  date: dateAsString,
  dateFormat,
  user,
  enableTimeDetailsTooltip,
}: {
  date?: string;
  dateFormat: DateFormat;
  user?: {
    initialLetters: string;
    displayName: string;
  };
  enableTimeDetailsTooltip?: boolean;
}): React.ReactElement {
  return (
    <span>
      {dateAsString ? (
        <FormattedDate
          dateAsString={dateAsString}
          enableTimeDetailsTooltip={enableTimeDetailsTooltip}
          format={dateFormat}
        />
      ) : null}
      {dateAsString && user ? <> ,&nbsp; </> : null}
      {user ? (
        <UserInitialsWithTooltip
          displayName={user.displayName}
          initials={user.initialLetters}
        />
      ) : null}
    </span>
  );
}

export const DateAndUser = observer(UDateAndUser);
